/*TODO Replace this file with typescript*/

export const NETWORK_ERROR = {
  HTTP_ERROR: 1,
  FETCH_ERROR: 2,
};
